import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const ZoneMaster = React.lazy(() => import('.'));

export const zoneMasterRoutes = [
  new Route({
    path: 'zone-master',
    element: ZoneMaster,
    children: [],
  }),
];
